import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { UserAgentDTO } from '../../../api/user-agent-api';
import SvgClose from '../../../assets/icons/Close';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveUserAgentModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedUserAgent?: UserAgentDTO;
    onHide: () => void;
    onSave: (values: UserAgentDTO) => void;
    onDelete?: (userAgent: UserAgentDTO) => void;
}

export function SaveUserAgentModal({
    show,
    allowEdit,
    selectedUserAgent,
    onHide,
    onSave,
    onDelete,
}: SaveUserAgentModalProps) {
    const UserAgentSchema = yup.object().shape({
        value: yup.string(),
        os: yup.string(),
        browser: yup.string(),
        device: yup.string(),
        brand: yup.string(),
        model: yup.string(),
    });

    const defaultValues: UserAgentDTO = {
        id: selectedUserAgent?.id,

        value: selectedUserAgent ? selectedUserAgent.value : '',
        os: selectedUserAgent ? selectedUserAgent.os : '',
        browser: selectedUserAgent ? selectedUserAgent.browser : '',
        device: selectedUserAgent ? selectedUserAgent.device : '',
        brand: selectedUserAgent ? selectedUserAgent.brand : '',
        model: selectedUserAgent ? selectedUserAgent.model : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={UserAgentSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="lg"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedUserAgent ? 'edit-user-agent' : 'new-user-agent'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="value"
                                name="value"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="os"
                                name="os"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="browser"
                                name="browser"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="device"
                                name="device"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="brand"
                                name="brand"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="model"
                                name="model"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
